export default __webpack_public_path__ + "19278d1632c54ea7d86bf038abe0243a.png";